import { render, staticRenderFns } from "./listOneChoiceProps.vue?vue&type=template&id=46f36a16&scoped=true&"
import script from "./listOneChoiceProps.vue?vue&type=script&lang=js&"
export * from "./listOneChoiceProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f36a16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VChip,VIcon,VTextField})
